interface SummaryBoxProps {
  text: string;
  label?: string;
}

/**
 * Shelby's owner-facing call summary, shown directly under the action grid.
 * Mock parity: .summary-box (ss-blue-light bg, 3px ss-blue left border).
 */
export function SummaryBox({ text, label = "Shelby's summary" }: SummaryBoxProps) {
  // Hide entirely when there's nothing to show — an empty box looks broken,
  // and most threads (SMS-only follow-ups, missed-call MCTBs) won't have a
  // Shelby-generated summary.
  const trimmed = (text ?? '').trim();
  if (!trimmed) return null;
  return (
    <div className="mx-4 mb-3 rounded-ss-sm border-l-[3px] border-ss-blue bg-ss-blue-light px-3.5 py-3 text-[13px] leading-relaxed text-ink-700 dark:bg-ss-blue/10 dark:text-[#CBD5E1]">
      <strong className="text-ss-blue-dark dark:text-[#93C5FD]">{label}:</strong> {trimmed}
    </div>
  );
}
